import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Hidden from "@material-ui/core/Hidden";
// import Divider from "@material-ui/core/Divider";
// import SettingsIcon from "@material-ui/icons/Settings";
import AirplayIcon from "@material-ui/icons/Airplay";
import Typography from "@material-ui/core/Typography";
import SettingsIcon from "@material-ui/icons/Settings";
// import PeopleIcon from "@material-ui/icons/People";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { languages } from "../constants/languages";
import Icon from "@mdi/react";
import { mdiTshirtCrew } from "@mdi/js";
import { mdiTournament } from "@mdi/js";
import { mdiScoreboard } from "@mdi/js";
import { mdiCalendarRange } from "@mdi/js";
import { Tooltip } from "@material-ui/core";

const drawerWidth = 85;

const styles = (theme) => ({
  root: {
    width: "100%",
    height: "100%",
    marginTop: theme.spacing(1),
    zIndex: 1,
    overflow: "hidden",
  },
  appFrame: {
    position: "relative",
    display: "flex",
    width: "100%",
    height: "100%",
  },
  drawerHeader: theme.mixins.toolbar,
  drawerPaper: {
    width: 90,
    [theme.breakpoints.up("md")]: {
      width: drawerWidth,
      position: "fixed",
      height: "100%",
    },
    borderRight: "0",
    backgroundColor: "white",
    zIndex: 0,
    overflowX: "hidden",
  },
  content: {
    backgroundColor: theme.palette.background.default,
    width: "calc(100% - 85px)",
    marginLeft: 85,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginLeft: 0,
    },
    padding: theme.spacing(1),
    height: "calc(100% - 56px)",
    [theme.breakpoints.up("sm")]: {
      height: "calc(100% - 64px)",
    },
    marginTop: 64,
    [theme.breakpoints.down("xs")]: {
      marginTop: 56,
    },
  },
  menuItem: {
    cursor: "pointer",
    textAlign: "center",
    width: drawerWidth,
    color: "#0000008a",
  },
  menuItemDisabled: {
    cursor: "normal",
    textAlign: "center",
    width: drawerWidth,
    color: "#0000008a",
  },
  listItem: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  backMenuItem: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
    paddingLeft: 0,
    paddingRight: 0,
  },
  typography: {
    color: "inherit",
  },
});

class TournamentNav extends React.Component {
  state = {
    expanded: false,
  };

  handleExpandClick = () => {
    this.setState((state) => ({ expanded: !state.expanded }));
  };

  render() {
    const { classes, theme } = this.props;
    const selectedColor = theme.palette.primary.main;
    const drawer = (
      <div>
        <div className={classes.drawerHeader} />
        {/* <List component="nav"> */}
        {/* <ListItem
            className={classes.backMenuItem}
            onClick={this.props.handleBack}
          >
            <div className={classes.menuItem}>
              <ArrowBackIcon />
              <br />
              <Typography variant="caption">
                {languages.tournament.back}
              </Typography>
            </div>
          </ListItem> */}

        {/* <ListItem
            disabled
            // onClick={e => {
            //   this.props.handleNavClick(e, "live");
            //   this.props.handleNavRoute(e, "/live");
            // }}
            className={classes.listItem}
            style={{
              background:
                this.props.selectedScreen === "live" ? "#e6e6e6" : null
            }}
          >
            <div
              className={classes.menuItem}
              style={{
                color:
                  this.props.selectedScreen === "live" ? selectedColor : null
              }}
            >
              <AirplayIcon />
              <br />
              <Typography variant="caption" className={classes.typography}>
                {languages.tournament.live}
              </Typography>
            </div>
          </ListItem> */}
        {/* </List> */}
        {/* <Divider /> */}
        <List>
          <ListItem
            className={classes.backMenuItem}
            onClick={this.props.handleBack}
          >
            <div className={classes.menuItem}>
              <ArrowBackIcon />
              <br />
              <Typography variant="caption">
                {languages.tournament.back}
              </Typography>
            </div>
          </ListItem>
          {(this.props.tournamentAdmin === undefined ||
            this.props.tournamentAdmin.manageGeneral) && (
            <ListItem
              onClick={(e) => {
                this.props.handleNavClick(e, "settings");
                this.props.handleNavRoute(e, "/settings");
              }}
              className={classes.listItem}
            >
              <div
                className={classes.menuItem}
                style={{
                  color:
                    this.props.selectedScreen === "settings"
                      ? selectedColor
                      : null,
                }}
              >
                <SettingsIcon />
                <br />
                <Typography variant="caption" className={classes.typography}>
                  {languages.tournament.generalSettings}
                </Typography>
              </div>
            </ListItem>
          )}
          {(this.props.tournamentAdmin === undefined ||
            this.props.tournamentAdmin.manageTeams) && (
            <ListItem
              className={classes.listItem}
              onClick={(e) => {
                this.props.handleNavClick(e, "teams");
                this.props.handleNavRoute(e, "/teams");
              }}
            >
              <div
                className={classes.menuItem}
                style={{
                  color:
                    this.props.selectedScreen === "teams"
                      ? selectedColor
                      : null,
                }}
              >
                {/* <PeopleIcon /> */}
                <Icon
                  path={mdiTshirtCrew}
                  size={1}
                  color={
                    this.props.selectedScreen === "teams"
                      ? selectedColor
                      : "#0000008a"
                  }
                />
                <br />
                <Typography variant="caption" className={classes.typography}>
                  {languages.tournament.participants}
                </Typography>
              </div>
            </ListItem>
          )}

          {(this.props.tournamentAdmin === undefined ||
            this.props.tournamentAdmin.manageFormat) && (
            <ListItem
              onClick={(e) => {
                this.props.handleNavClick(e, "structure");
                this.props.handleNavRoute(e, "/structure");
              }}
              className={classes.listItem}
            >
              <div
                className={classes.menuItem}
                style={{
                  color:
                    this.props.selectedScreen === "structure"
                      ? selectedColor
                      : null,
                }}
              >
                {/* <DashboardIcon /> */}
                <Icon
                  path={mdiTournament}
                  size={1}
                  color={
                    this.props.selectedScreen === "structure"
                      ? selectedColor
                      : "#0000008a"
                  }
                />
                <br />
                <Typography variant="caption" className={classes.typography}>
                  {languages.tournament.allocation}
                </Typography>
              </div>
            </ListItem>
          )}
          {(this.props.tournamentAdmin === undefined ||
            this.props.tournamentAdmin.manageSchedule) && (
            <ListItem
              onClick={(e) => {
                if (!this.props.tournament.online) {
                  this.props.handleNavClick(e, "schedule");
                  this.props.handleNavRoute(e, "/schedule");
                }
              }}
              className={classes.listItem}
              disabled={this.props.tournament.online || false}
            >
              <Tooltip
                title={
                  this.props.tournament.online
                    ? languages.tournament.noScheduleOnline
                    : ""
                }
                placement="right"
                enterTouchDelay={0}
              >
                <div
                  className={
                    this.props.tournament.online
                      ? classes.menuItemDisabled
                      : classes.menuItem
                  }
                  style={{
                    color:
                      this.props.selectedScreen === "schedule"
                        ? selectedColor
                        : null,
                  }}
                >
                  {/* <TimerIcon /> */}
                  <Icon
                    path={mdiCalendarRange}
                    size={1}
                    color={
                      this.props.selectedScreen === "schedule"
                        ? selectedColor
                        : "#0000008a"
                    }
                  />
                  <br />
                  <Typography variant="caption" className={classes.typography}>
                    {languages.tournament.schedule}
                  </Typography>
                </div>
              </Tooltip>
            </ListItem>
          )}
          {(this.props.tournamentAdmin === undefined ||
            this.props.tournamentAdmin.managePresentation) && (
            <ListItem
              onClick={(e) => {
                this.props.handleNavClick(e, undefined);
                this.props.handleNavRoute(e, "");
              }}
              className={classes.listItem}
            >
              <div
                className={classes.menuItem}
                style={{
                  color:
                    this.props.selectedScreen === undefined ||
                    this.props.selectedScreen === "signup"
                      ? selectedColor
                      : null,
                }}
              >
                <AirplayIcon />
                <br />
                <Typography variant="caption" className={classes.typography}>
                  {languages.tournament.presentation}
                </Typography>
              </div>
            </ListItem>
          )}
          {(this.props.tournamentAdmin === undefined ||
            this.props.tournamentAdmin.manageResults) && (
            <ListItem
              onClick={(e) => {
                this.props.handleNavClick(e, "results");
                this.props.handleNavRoute(e, "/results");
              }}
              className={classes.listItem}
            >
              <div
                className={classes.menuItem}
                style={{
                  color:
                    this.props.selectedScreen === "results"
                      ? selectedColor
                      : null,
                }}
              >
                {/* <ViewListIcon /> */}
                <Icon
                  path={mdiScoreboard}
                  size={1}
                  color={
                    this.props.selectedScreen === "results"
                      ? selectedColor
                      : "#0000008a"
                  }
                />
                <br />
                <Typography variant="caption" className={classes.typography}>
                  {languages.tournament.results}
                </Typography>
              </div>
            </ListItem>
          )}
        </List>
      </div>
    );

    return (
      <div className={classes.root}>
        <div className={classes.appFrame}>
          {!this.props.new && (
            <Hidden mdUp>
              <Drawer
                variant="temporary"
                anchor={theme.direction === "rtl" ? "right" : "left"}
                open={this.props.mobileOpen}
                classes={{
                  paper: classes.drawerPaper,
                }}
                onClose={this.props.handleDrawerToggle}
                ModalProps={{
                  style: { zIndex: 2 },
                  keepMounted: true, // Better open performance on mobile.
                }}
              >
                {drawer}
              </Drawer>
            </Hidden>
          )}
          {!this.props.new && (
            <Hidden smDown implementation="css">
              <Drawer
                variant="permanent"
                open
                classes={{
                  paper: classes.drawerPaper,
                }}
              >
                {drawer}
              </Drawer>
            </Hidden>
          )}
          {this.props.new ? (
            this.props.children
          ) : (
            <main className={classes.content}>{this.props.children}</main>
          )}
        </div>
      </div>
    );
  }
}

TournamentNav.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(TournamentNav);
